export default (theme) => ({
  root: { width: '100%' },
  stepperActionsContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  flex: { flex: 1 },
  skipContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: { margin: theme.spacing(0.5) },
  resetContainer: { padding: theme.spacing(3) },
  headlineContainer: {
    maxWidth: '100%',
    margin: 'auto',
    background: '#484653',
    padding: '2em',
    color: 'white',
  },
  headline: {
    textAlign: 'center',
    margin: '.5em 0 0',
  },
  subHeadline: { textAlign: 'center' },
  tutorialButton: { margin: theme.spacing(1) },
  stepContent: { margin: theme.spacing(2) },
  bigAvatar: {
    display: 'inline',
    marginLeft: 10,
    marginBottom: 20,
    width: 60,
    height: 60,
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  stepperContainer: { padding: '1em' },
  textCenter: { textAlign: 'center' },
  activeStep: {
    textAlign: 'center',
    marginBottom: '1em',
  },
});
